module.exports = __webpack_public_path__ + "src/img/Triangles.0f98c4cd.gif";